import format from "date-fns/format";

export const unixTimestampConverter = (UNIX_timestamp) => {
	return new Date(UNIX_timestamp).toLocaleString("en-US");
};

export const isoStringToDateTime = (isoString) => {
	return isoString ? format(new Date(isoString), "yyyy-MM-dd h:mm a") : "";
};
